export function decodeHtml(value) {
  const map = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#039;': "'"
  };
  return value.replace(/&amp;|&lt;|&gt;|&quot;|&#039;/g, (v) => map[v]);
}
